import React from 'react'
import { Pagination } from '../ui/Pagination'

/**
 * Pager for report screens with their own table markup. Keeps the old
 * PrimeReact-style API: `first` (row offset), `rows`, `onPageChange({ first, rows, page })`.
 */
const ReportPaginator = ({ first = 0, rows = 10, totalRecords = 0, onPageChange, rowsPerPageOptions = [10, 20, 50] }) => {
  const page = Math.floor(first / (rows || 1))
  return (
    <Pagination
      page={page}
      pageSize={rows}
      total={totalRecords}
      pageSizeOptions={rowsPerPageOptions}
      onPageChange={(p) => onPageChange?.({ first: p * rows, rows, page: p, pageCount: Math.ceil(totalRecords / rows) })}
      onPageSizeChange={(n) => onPageChange?.({ first: 0, rows: n, page: 0, pageCount: Math.ceil(totalRecords / n) })}
    />
  )
}

export default ReportPaginator
